import { memo } from "react";
import styles from "./CommonFormFieldWrapper.module.scss";

type Props = {
	title?: string;
	errors?: string[];
	required?: boolean;
	currency?: string;
	/** Read-only text pinned to the right of the input. Unlike currency it is not width-capped. */
	suffix?: string;
	description?: string;
	fieldTouched?: boolean;
	fieldValue?: any;
	borderNotVisible?: boolean;
	disabled?: boolean;
	childrenColumnDirection?: boolean;
	children: React.ReactNode;
};

const CommonFormFieldWrapper: React.FC<Props> = memo((props: Props) => {
	document.querySelectorAll<HTMLInputElement>('input[type="number"]').forEach(input => {
		input.addEventListener("wheel", (event: WheelEvent) => {
			if (document.activeElement === input) {
				// Temporarily unfocus the input to prevent value change on scroll
				input.blur();
				setTimeout(() => input.focus(), 0); // Refocus to maintain user experience
			}
		});
	});

	return (
		<div className={styles.formField}>
			{props.title && (
				<div className={styles.formFieldTitle}>
					{props.title ? props.title : null}
					{props.required && <span className={styles.required}> *</span>}
				</div>
			)}

			<div
				className={
					((props.errors && props.errors.length > 0) || (props.fieldTouched && props.fieldValue === undefined)
						? styles.formFieldInputContainerInvalid
						: styles.formFieldInputContainer) +
					" " +
					(props.borderNotVisible && styles.noBorder) +
					" " +
					(props.disabled && styles.disabled) +
					" " +
					(props.childrenColumnDirection && styles.columnDirection)
				}
			>
				{props.children}
				{props.currency && <div className={styles.currency}>{props.currency}</div>}
				{props.suffix && <div className={styles.suffix}>{props.suffix}</div>}
			</div>
			{props.errors && (
				<div className={styles.errors}>
					{props.errors?.map((error: string, index: number) => (
						<div key={index} className={styles.error}>
							{error}
						</div>
					))}
				</div>
			)}
			{props.description && <div className={styles.description}>{props.description && <div>{props.description}</div>}</div>}
		</div>
	);
});

export function getFormInputErrors(error: string | undefined): string[] {
	return error ? [error] : [];
}

export default CommonFormFieldWrapper;
